import { RECAPTCHA_SITE_KEY } from "../../config/config";

export const getRecaptchaToken = async (action) => {
  if (!window.grecaptcha) {
    throw new Error("reCAPTCHA no cargado");
  }
  return await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
    action
  });
};